import {
  easypostFedexMfaValidatePinInputSchema,
  easypostFedexMfaValidatePinOutputSchema,
} from "@redotech/redo-model/carrier-account/easypost-fedex-mfa";

export const easypostFedexMfaValidatePin = {
  name: "easypostFedexMfaValidatePin" as const,
  input: easypostFedexMfaValidatePinInputSchema,
  output: easypostFedexMfaValidatePinOutputSchema,
};
